import React from 'react';
import Table from '../../components/common/Table';
import { convertToUserTime } from '../../utils/helpers/convertToUserTime';

interface RewardTableProps {
  data: any[];
  handleEdit: (service: any) => void;
  handleDelete: (service: any) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const RewardTable: React.FC<RewardTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Name',
          key: 'name',
        },
        {
          label: 'Description',
          key: 'description',
        },
        {
          label: 'StartRange',
          key: 'startRange',
        },
        {
          label: 'EndRange',
          key: 'endRange',
        },
        {
          label: 'Created',
          key: 'createdUtc',
          render: (row) => (
            <span>{convertToUserTime(row.createdUtc)}</span>
          ),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default RewardTable;
